module.exports = __webpack_public_path__ + "static/img/choose_2_2.0cd8f50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/choose_2_2.png
// module id = ljks
// module chunks = 0